import { render, staticRenderFns } from "./ctgrLayer.vue?vue&type=template&id=22190992&"
import script from "./ctgrLayer.vue?vue&type=script&lang=js&"
export * from "./ctgrLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports